<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-27 17:13:10
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-27 17:14:10
 * @FilePath: /chaoyongtuan/src/views/cooperativeShop/collaborateRules/viewRules/components/tabCell/shopStrore.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<platform-icon style="flex-shrink: 0" :platformId="row.platform_id" />
		<span class="ml-4">{{ row.shopName | formatEmpty }}</span>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {},
	computed: {},
	data() {
		return {};
	},
	methods: {},
};
</script>
